import * as Types from '../../../types/bff/gql-schema';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const SearchHospitalGenerallyDocument = `
    query SearchHospitalGenerally($request: HospitalGeneralSearchRequestInput!) {
  searchHospitalGenerally(request: $request) {
    elements {
      hospitalId
      hospitalPublicId
      hospitalRepresentativeImageUrl
      hospitalName
      hospitalAddress
      hospitalDistance
      hospitalBadges
      hospitalOperationStatus
      hospitalRepresentativeDepartmentName
      reviewAverageRating
      reviewTotalCount
      isBookable
      operationDisplay
      hospitalAdBanners {
        displayDiscount
        hospitalId
        id
        displayPrice
        thumbnailImageUrl
        title
        url
      }
      doctors {
        name
        publicId
        reviewAverageRating
        medicineType
        reviewTotalCount
        readyForVideoCall
        detail {
          contractType
          profileImageUrl
        }
        departments {
          name
          isProfessional
        }
        hospital {
          hospitalName
        }
      }
    }
    pivot
    pivotScore
    totalCount
  }
}
    `;
export const useSearchHospitalGenerallyQuery = <
      TData = Types.SearchHospitalGenerallyQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.SearchHospitalGenerallyQueryVariables,
      options?: UseQueryOptions<Types.SearchHospitalGenerallyQuery, TError, TData>,
    ) =>
    useQuery<Types.SearchHospitalGenerallyQuery, TError, TData>(
      ['SearchHospitalGenerally', variables],
      gqlFetcher<Types.SearchHospitalGenerallyQuery, Types.SearchHospitalGenerallyQueryVariables>(SearchHospitalGenerallyDocument, 'SearchHospitalGenerally', variables),
      options
    );

useSearchHospitalGenerallyQuery.getKey = (variables: Types.SearchHospitalGenerallyQueryVariables) => ['SearchHospitalGenerally', variables];
;

useSearchHospitalGenerallyQuery.fetcher = (variables: Types.SearchHospitalGenerallyQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.SearchHospitalGenerallyQuery, Types.SearchHospitalGenerallyQueryVariables>(SearchHospitalGenerallyDocument, 'SearchHospitalGenerally', variables, options);